import { JtiDocumentAdditionalInfo } from '.';
import { JtiAdditionalAddress } from './jti-additional-address.model';
import { ChangeAddress } from './change-address.model';

export class JtiDocumentAdditionalInfoForNewAddress extends JtiDocumentAdditionalInfo {
  value: ChangeAddress;
}
